module.exports = __webpack_public_path__ + "img/product-preview-77.8a2f63f.png";